import React from 'react';
import { connect } from 'react-redux';
import { verificarEmail } from './services.act.js'
import { movil } from '../app-movil';
import { authentication } from '../app-database';
import isMobile from 'ismobilejs';
import { goTo } from "../tools";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Modal from '../generalcomponets/modal-mobile'
import { clearSubmit } from 'redux-form';



const mapState = (state) => {
	return {
		error: state.olvide.flagError,
		mensaje: state.olvide.errorMsj,
		loader: state.global.loader,
		dispositivo: state.global.dispositivo
	};
}

const mapDispatch = (dispatch) => {
	return {
		resetPaso: () => {
			dispatch({ "type": "OLVIDE_RESET_PASO" });
		},
		verificarEmail: (correo,disp) => {
			dispatch({ "type": "LOGIN_SET_CORREO", 
					  "correo" : correo
				  });
			dispatch({ "type": "RECUPERAR_SET_FLAG_ERROR", 
					  "flag" : false
				  });
			dispatch(verificarEmail(correo,disp));
		},
		showLoading: () => {
			dispatch({ "type": "LOADER_SHOW"});
		},
		clearError: () => {
			dispatch({ "type": "OLVIDE_SET_FLAG_ERROR", 
					  "flag" : false
				  });
		}
		
	}
}

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: '24px',
		letterSpacing: '0.5px',
		color: '#0C2040',
}

const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#647085',
}

class IngresaCorreo extends React.Component {
	
	state = {
		inputType: "password",
		inputClass: "input-wrap ver-input mt-30",
		inputActive: "",
		error: false,
		errorMsj: this.props.mensaje,
		email: "",
		checkFlag: false,
		bloqueado: false,
		isModalOpened: false
	}

	componentDidUpdate(prevProps){
		if(prevProps.paso !== this.props.paso)
			if(this.props.paso === 1)
				this.setState({isModalOpened: true});
	}
	
	validateEmail = (email) => {
		var pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return pattern.test(email); 
	}
	changeInputType = () => {
		let type = this.state.inputType;
		this.setState({inputType: type == 'password' ? 'text' : 'password'});
		this.setState({inputClass: type == 'password' ? 'input-wrap visible-input mt-30' : 'input-wrap ver-input mt-30'});
	}
	validarEmail = (emailI) => {
		console.log("Entro a validar email");
		let email = this.refs.email.value || emailI;
		this.setState({bloqueado: true});
		this.setState({checkFlag: true});
		if(!this.props.loader && !this.state.bloqueado){
			
			if(!email) {
				this.setState({error: true});
				this.setState({errorMsj: "Campo requerido."});
				this.setState({bloqueado: false});
			}
			else if(!this.validateEmail(email)) {
				this.setState({error: true});
				this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
				this.setState({bloqueado: false});
			}
			else {
				this.props.showLoading();
				let $this = this;
				$this.props.verificarEmail(email,$this.props.dispositivo);
				this.setState({bloqueado: false});
			}
		}
	}
	handleBlur = (event) => {
		let mail = event.target.value;
		this.setState({email: mail});
		this.setState({inputActive: mail ? "input-active" : ""});
		this.setState({error: false});
		this.props.clearError();
		let email = event.target.value.trim();
		this.refs.email.value = email;
		if(email.length >1 && !this.validateEmail(email)) {
			this.setState({error: true});
			this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
			this.setState({bloqueado: false});
		}
	}
	handleFocus = (event) => {
		this.setState({inputActive: "input-active"});
		this.setState({errorMsj: ""});
		//event.target.value = this.state.error ? "" : event.target.value;
		this.setState({error: false});
		this.props.clearError();
		let email = event.target.value;
		if(email.length >1 && !this.validateEmail(email)) {
			this.setState({error: true});
			this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
			this.setState({bloqueado: false});
		}
	}
	regresar = () => {
		let mensaje = {"return": "login", "procesa": "recupera"};
		movil("cambiarcontrasena", mensaje);
		goTo("login");
	}
	_handleKeyPress = (event) => {
		let email = event.target.value;

		if(this.state.error) {
			this.setState({error: false});
			this.setState({errorMsj: ""});
		}
		if (event.key === 'Enter') {
			this.validarEmail(email); 
		}
	}
	handleChange = (event) => {
		let email = event.target.value;
		if(this.state.checkFlag) {
			if(!this.validateEmail(email)) {
				this.setState({error: true});
				this.setState({errorMsj: "El correo electrónico no es válido. Favor de verificar."});
			} else {
				this.setState({error: false});
				this.setState({errorMsj: ""});
			}
		}
	}

	regresar = () => {
		let mensaje = {"return": "login", "procesa": "recupera"};
		movil("cambiarcontrasena", mensaje);
		this.props.resetPaso();
		this.closeModalFromChild();
		//window.location.href = '/#!/login';
	}

	openModalParent = () => {
		let { isModalOpened } = this.state;

		if(isModalOpened)
		  this.setState({ isModalOpened: false})
		else{
		  this.setState({ isModalOpened: true});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false})
	  }
	
	render() {
		const pError = this.props.error;
		const pErrorM = this.props.mensaje;
		const sError = this.state.error;
		const sErrorM = this.state.errorMsj;
		return (<div>
			<MuiThemeProvider>
		<div id="olvide_container">
		<div className="container">

			
			<div className="olvide-margin-mobile">
			<div className="row">
				<div className="col-md-12 col-sm-12 col-xs-12">
					<p className="new-info-text">
						Captura el correo electrónico con el que te registraste para enviarte los pasos a seguir e ingreses a tu cuenta.
					</p>
				</div>
				<div className="col-md-12 col-sm-12 col-xs-12">
					<TextField
						ref="email"
						type="email"
						floatingLabelText="Correo electrónico"
						fullWidth={true}
						underlineStyle={{borderColor: '#AAC3EE'}}
						underlineFocusStyle={{borderColor: '#AAC3EE'}}
						floatingLabelStyle={floatingLabelStyleSettings}
						floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.onChange}
						onKeyPress={this._handleKeyPress}
						errorText={(pError && pErrorM) || (sError && sErrorM)}
					/>
					
				</div>
				<div className="olvide-button-container">

					<div className="container">
						<button onClick={this.validarEmail} disabled={this.state.bloqueado} className="pure-material-button-contained btn-full-width" style={{marginTop: '40px'}}>Continuar</button>
					</div>
				</div>
			</div>
			</div>
			
		</div>
		</div>
		
		</MuiThemeProvider>
		
		{this.state.isModalOpened &&
			<Modal closeModalFromChild={this.regresar}>
				<div className="container">
					<div className="row">
						<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal margin-modal-top">
							<label className="gnp-material-title-modal">Revisa tu correo electrónico</label>
						</div>
						<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
							<p className=" gnp-material-content-modal">Haz clic en el enlace que te enviamos para restablecer tu contraseña.</p>
						{/* </div>
						<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal"> */}
							<p className=" gnp-material-content-modal">Si no ves el correo electrónico en tu bandeja de entrada revisa otras <br className="hide-mobile" />carpetas como spam.</p>
						</div>
						<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
							<button type="button" onClick={this.regresar} className="pure-material-button-contained btn-full-width">Aceptar</button>
						</div>
					</div>
				</div>
			</Modal>}
		</div>
		);
	}
}

export default connect(mapState, mapDispatch)(IngresaCorreo);


// WEBPACK FOOTER //
// ./src/gnp-olvide/ingresaCorreoMovil.cmpt.js